import { Container, Row, Col } from "react-bootstrap";

export default function NoResultsTable() {
  return (
    <Container fluid className={"bplaced-wrapper"}>
      <Row>
        <Container fluid>
          <Col md={12} className="d-flex flex-column align-items-center justify-content-center">
            <p>No results found.</p>
          </Col>
        </Container>
      </Row>
    </Container>
  );
}
